<section class="section-online-check-content">
  <form [hidden]="!showDepositForm" [formGroup]="onlineCheckForm">
    <div >
      <p class="label tw-text-[16px]">{{ 'ui.funding.deposit.amount' | translate: 'Deposit Amount' }}</p>
      <div class="amount-row tw-relative">

        <!-- Message section -->
        <span class="tw-absolute tw-top-[-18px] tw-right-[0px] tw-h-[18px] tw-block tw-pt-[2px]">

          <!-- Required -->
          <span
            class="tw-block tw-text-right tw-text-xs tw-text-[#D83A19]"
            *ngIf="formVal['amount'] && formVal['amount']?.errors
              && (formVal['amount'].touched || formVal['amount'].dirty)"
          >
            {{
              formVal['amount']?.errors?.['min']
                ? ('ui.funding.deposit.min.25' | translate: 'Cannot deposit less than $25.')
                : formVal['amount']?.errors?.['max']
                  ? ('ui.funding.deposit.max.1000' | translate: 'Cannot deposit greater than $1000.')
                  : ('ui.funding.enter.valid.amount' | translate: 'Please enter valid amount.')
            }}
          </span>
        </span>

        <input
          formControlName="amount"
          id="depositAmount"
          (keyup)="depositAmount()"
          type="number"
          min="25"
          max="1000"
          class="amount tw-h-[38px] tw-text-[22px] tw-text-[#645858]"
          placeholder="25"
          pattern="^\d+(\.\d{1,2})?$"
          amwager3DecimalInput
        />
      </div>
      <div class="tw-flex tw-mt-[6px] tw-mb-[22px] tw-justify-between">
        <span
          (click)="chooseAmount(500.00)"
          class="choose-amount tw-text-[16px]"
        >
          $500
        </span>
        <span
          (click)="chooseAmount(200.00)"
          class="choose-amount tw-text-[16px]"
        >
          $200
        </span>
        <span
          (click)="chooseAmount(100.00)"
          class="choose-amount tw-text-[16px]"
        >
          $100
        </span>
        <span
          (click)="chooseAmount(50.00)"
          class="choose-amount tw-text-[16px]"
        >
          $50
        </span>
        <span
          (click)="chooseAmount(25.00)"
          class="choose-amount tw-text-[16px]"
        >
          $25
        </span>
      </div>

      <div class="mid-line"></div>

      <div class="online-check-content">

        <p class="label tw-ml-[9px]">{{ 'account.funding.account.choose' | translate: 'Choose Account:' }} </p>
        <div class="online-check-list-container">
          <div class="online-check-lists">
            <div
              *ngIf="(accounts$ | async)| isEmpty"
              class="empty-account tw-pl-[8px] tw-pb-[20px]"
            >
              {{ 'ui.funding.please.add.account.to.deposit' | translate: 'Please add account to deposit.' }}
            </div>

            <div
              *ngFor="let account of accounts$ | async; let i = index"
              (click)="chooseAccount($event, 'achAccount', ('account-' + i), account.AccountId)"
              id="account-{{i}}"
              class="online-check-per-row tw-flex tw-w-full tw-justify-between tw-items-center"
            >
              <div class="tw-flex tw-items-center tw-w-[50%]">
                <span class="selector tw-flex"></span>

                <span class="online-check-name tw-text-[13px] tw-text-[#000000] tw-font-bold tw-ml-[8px]">
                  {{ account.AchName }}
                </span>
              </div>

              <div class="tw-flex tw-w-[20%]">
                <span class="online-check-ending tw-text-[12px]">
                  <span class="tw-font-bold tw-text-[#000000]">
                    {{ account.AchAccount.toString() | slice:-4 }}
                  </span>
                </span>
              </div>

              <div class="tw-flex">
                <mat-icon
                  (click)="confirmRemoveAccount(account.AccountId)"
                  class="delete-online-check tw-text-[20px] tw-t-[-2px] tw-relative">
                  delete_outline
                </mat-icon>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="online-check-container">
        <button
          (click)="openAddAccount()"
          class="add-online-check active tw-w-[100%] tw-h-[41px] tw-text-[16px] tw-mt-[15px]"
        >
          {{ 'account.funding.bank.add' | translate: 'Add Account' }}
        </button>
      </div>

      <p class="label tw-text-[16px]">{{ 'account.funding.deposit.before.btn' | translate: 'Funds will be deposited:' }}</p>

      <button
        (click)="deposit()"
        [ngClass]="
          {
            'active': (
              amount &&
              bankAccountId &&
              isAgree &&
              !isDepositing &&
              formVal['amount'].valid
            )
          }
        "
        [disabled]="
          !amount ||
          !bankAccountId ||
          !isAgree ||
          isDepositing ||
          formVal['amount'].invalid
        "
        type="submit"
        class="deposit-now tw-w-full tw-h-[41px] tw-text-[16px] tw-mt-[10px]"
      >
        {{ 'account.funding.deposit.now' | translate: 'Deposit Now' }}
      </button>

      <div class="tw-mt-[15px]">
        <p class="tw-text-[15px]">
          {{ 'account.funding.deposit.ach.agreement' | translate: 'By clicking Deposit Now, I agree to the Terms and Conditions of ACH Deposit. I understand my IP and location will be recorded for fraud prevention.' }}
        </p>

        <p class="tw-text-[15px] tw-mt-[15px]">
          <span class="label tw-font-bold">{{ 'generic.note' | translate: 'Note:' }}</span>
          {{
            'ui.funding.deposit.limit.note'
              | translate: '' : {
                  limit: (customerFundingLimit | number: '1.2'),
                  available: (availableFundingLimit | number: '1.2')
                }
          }}
        </p>

        <p class="tw-text-[15px] tw-mt-[15px]">
          {{ 'ui.funding.i.hereby.authorize.amwager.com.to.2' | translate }}
        </p>
      </div>

      <div class="terms-and-condition-container tw-flex tw-mt-[15px]">
        <mat-checkbox
          [checked]="isAgree"
          (change)="toggleCheckbox()"
          id="termsAndCondition"
          class="active-limit tw-top-1 tw-mt-0 tw-mr-[4px] tw-mb-0">
        </mat-checkbox>
        <span
          (click)="toggleCheckbox()"
          class="agree tw-self-center tw-font-bold tw-text-[15px] tw-mt-[8px]"
        >
          {{ 'account.funding.agreeterms' | translate: 'I agree to the above terms' }}
        </span>
      </div>

      <p class="tw-text-[15px] tw-text-[#D83A19] tw-mt-[15px]">{{ 'generic.checkboxerror' | translate: 'Please check the box' }}</p>

    </div>
  </form>

  <div
    [hidden]="!showDepositForm || (pendingList$ | async) | isEmpty"
    class="pending-deposit-list tw-mt-[50px]"
  >
    <p class="label tw-text-[16px]">{{ 'generic.pending' | translate: 'Pending' }}</p>

    <div class="table tw-mt-[20px]">
      <div class="table-header">
        <div class="col tw-font-bold tw-text-[15px]">{{ 'generic.date' | translate: 'Date' }}</div>
        <div class="col tw-font-bold tw-text-[15px]">{{ 'Amount' | translate: 'Amount' }}</div>
      </div>

      <div *ngFor="let item of pendingList$ | async; let i = index" class="table-row">
        <div class="col tw-text-[12px]">
          {{ item.Date | dateFormat: 'MMMM DD, YYYY' }}
        </div>
        <div class="col tw-text-[12px]">
          {{ item.Amount | number:'1.2' }}
        </div>
      </div>
    </div>
  </div>

  <feature-mat-add-account
    [hidden]="!showAddAccountForm"
    (showAddAccountFormFn)="closeAddAccountForm($event)"
  >
  </feature-mat-add-account>
</section>
